<template>
  <div class="iq-card map-card h-100 w-100">
    <div class="iq-card-body">
      <div class="fms-card-header">
        <div>
          <h4>Main Map &amp; Movement</h4>
          <p class="text-muted">Monitor geographic position and trail history.</p>
        </div>
      </div>
      <div class="map-section">
        <Map
          v-if="currAsset"
          :ships="[currAsset]"
          SelectedMap="default"
          :center="center"
          :zoom="zoom"
          :Options="{ enableTrail: true, disableSummaryFetch: true }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Map from '@/views/map';

export default {
  name: 'FmsMapSection',
  components: {
    Map,
  },
  props: {
    currAsset: {
      type: Object,
      default: null,
    },
    center: {
      type: Object,
      default: null,
    },
    zoom: {
      type: Number,
      default: 10,
    },
  },
};
</script>

<style scoped>
.map-section {
  min-height: 454px;
  height: 454px;
  border-radius: 16px;
  overflow: hidden;
}

.map-card .iq-card-body {
  padding: 15px 20px;
}
</style>
